import styled from 'styled-components';

const QuestionsWrapper = styled.div`
    box-sizing: border-box;
    outline: none;
`;

export default QuestionsWrapper;



// WEBPACK FOOTER //
// ./src/kentico-blocks/SimpleAccordion/QuestionsWrapper.jsx